export default {
  "articles": "Articles",
  "search": "Search",
  "refresh": "Refresh",
  "add": "Add",
  "importWeChatArticles": "Import WeChat articles",
  "noArticlesYet": "No articles yet",
  "categories": "Categories",
  "articleTitle": "Article title",
  "articleType": "Article type",
  "text": "Text",
  "link": "Link",
  "weChatArticle": "WeChat article",
  "publisher": "Publisher",
  "coverImage": "Cover image",
  "status": "Status",
  "visible": "Visible",
  "hidden": "Hidden",
  "order": "Order",
  "publishedAt": "Published at",
  "actions": "Actions",
  "editArticle": "Edit article",
  "addArticle": "Add article",
  "category": "Category",
  "pleaseSelectACategory": "Please select a category",
  "enterThePublisherName": "Enter the publisher name",
  "cover": "Cover",
  "uploading": "Uploading…",
  "uploadCover": "Upload cover",
  "remove": "Remove",
  "copyOrPasteACoverImageURL": "Copy or paste a cover image URL",
  "weChatArticleURL": "WeChat article URL",
  "destinationURL": "Destination URL",
  "views": "Views",
  "selectDateAndTime": "Select date and time",
  "content": "Content",
  "enterArticleContent": "Enter article content",
  "attachment": "Attachment",
  "attachmentURL": "Attachment URL",
  "upload": "Upload",
  "oK": "OK",
  "coverPreview": "Cover preview",
  "articleCover": "Article cover",
  "all": "All",
  "selectAnArticleType": "Select an article type",
  "enterAnArticleTitle": "Enter an article title",
  "enterADestinationURL": "Enter a destination URL",
  "pleaseSelectAStatus": "Please select a status",
  "couldNotUploadContentImage": "Could not upload content image",
  "couldNotLoadData": "Could not load data",
  "couldNotLoadCategories": "Could not load categories",
  "uploadFailed": "Upload failed",
  "coverUploaded": "Cover uploaded",
  "couldNotUploadCover": "Could not upload cover",
  "attachmentUploaded": "Attachment uploaded",
  "couldNotUploadAttachment": "Could not upload attachment",
  "articleUpdated": "Article updated",
  "articleCreated": "Article created",
  "couldNotSaveChanges": "Could not save changes",
  "deleteArticle": "Delete article “{p0}”?",
  "deleteArticle060": "Delete article",
  "deleted": "Deleted",
  "couldNotDelete": "Could not delete",
  "noCategoriesYet": "No categories yet",
  "categoryName": "Category name",
  "edit": "Edit",
  "pleaseEnterACategoryName": "Please enter a category name",
  "enterACategoryName": "Enter a category name",
  "categoryUpdated": "Category updated",
  "categoryCreated": "Category created",
  "deleteCategory": "Delete category “{p0}”?",
  "deleteCategory071": "Delete category",
  "readLinks": "Read links",
  "manualImport": "Manual import",
  "articleLinks": "Article links",
  "oneLinkPerLineUpTo5": "One link per line, up to 5 links",
  "openAWeChatArticleChooseCopyLink": "Open a WeChat article, choose Copy link in the top-right menu, and paste it below.",
  "pasteWeChatArticleLinksEGHttps": "Paste WeChat article links, e.g. https://mp.weixin.qq.com/s/…",
  "afterReadingYouCanAddOrEdit": "After reading, you can add or edit titles and covers manually.",
  "readArticleInformation": "Read article information",
  "openWeChatAccountSettings": "Open WeChat account settings",
  "confirmArticleInformation": "Confirm article information",
  "selectArticle": "Select article {p0}",
  "noCover": "No cover",
  "viewOriginal": "View original",
  "imported": "Imported",
  "delete": "Delete",
  "httpsMpWeixinQqComSRequired": "https://mp.weixin.qq.com/s/… (required)",
  "title": "Title",
  "articleTitleRequired": "Article title (required)",
  "coverImageURLOptional": "Cover image URL (optional)",
  "importCategory": "Import category",
  "selectAnArticleCategory": "Select an article category",
  "noCategoriesAvailableAddACategoryAnd": "No categories available. Add a category and set it to Visible first.",
  "previouslyImportedArticlesWillBeSkipped": "· Previously imported articles will be skipped",
  "cancel": "Cancel",
  "couldNotLoadDataTryAgainLater": "Could not load data. Try again later.",
  "enter1To5ArticleLinksOne": "Enter 1 to 5 article links, one per line.",
  "couldNotReadArticlesTryAgainLater": "Could not read articles. Try again later.",
  "enterATitleForEachSelectedArticle": "Enter a title for each selected article.",
  "enterAValidWeChatURLForEach": "Enter a valid WeChat URL for each selected article.",
  "importFailedCheckTheArticleInformation": "Import failed. Check the article information.",
  "recordRange": "Showing {from}–{to} of {total} records",
  "articleCount": "Articles: {count}",
  "publisherCaption": "Publisher: {name}",
  "articleNumber": "Article {number}",
  "addArticleCount": "Add article ({count}/5)",
  "selectedCount": "Selected: {count}",
  "confirmImportCount": "Import ({count})",
  "importResult": "Articles imported: {count}",
  "importResultWithSkipped": "Articles imported: {count}; existing articles skipped: {skipped}",
  "accountNotConfigured": "Set the WeChat account name in account settings first. It will be used as the publisher.",
  "invalidWeChatLink": "Enter a WeChat article link from mp.weixin.qq.com.",
  "incompleteWeChatLink": "The link is incomplete. Use Copy link in WeChat to get the original article URL.",
  "previewBusy": "The article reader is busy. Try again later.",
  "previewTimedOut": "Reading timed out. Enter the information manually or try again later.",
  "metadataUnavailable": "WeChat did not return article information. Enter the title and cover manually.",
  "coverUnavailable": "Could not read the cover. You can enter an image URL manually.",
  "wechatVerificationRequired": "WeChat requires verification. Enter the title and cover manually.",
  "metadataReadFailed": "Could not read article information. Enter the title and cover manually.",
  "backToList": "Back to list",
  "previewBusyForAssociation": "Articles are already being read for this association. Try again later.",
  "importBusy": "Articles are already being imported for this association. Try again later.",
  "selectionExpired": "The article selection expired or the account settings changed. Refresh and select again.",
  "accountConfigurationChanged": "The WeChat account settings changed. Read the articles again.",
  "categoryUnavailable": "The category is unavailable or hidden. Select another category."
}
